import { Grid } from "@mui/material";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../..";
import CustomisedButton from "../../components/button/button";
import { UUID } from "../../config/cacheKey";
import { setUnAuthorizedState } from "../../redux/unAuthorizedState/unAuthorizedStateSlice";
import { TUnauthorizedState } from "../../routeWithState/IRouteWithState";
import { GetPrivacyStatement } from "../../services/basicInformation.service";
import PrivaceStatementsSkeleton from "./privaceStatementsSkeleton";


const PrivacyStatements = () => {
    const dispatch = useDispatch()
    const unAuthorized_Redux = useSelector(
        (state: RootState) => state.unAutorizedState.state
    ) as TUnauthorizedState;

    const { data: privacyStatement, isLoading } = useQuery('privacyStatement', GetPrivacyStatement, {
        staleTime: 1000 * 60 * 30,
        cacheTime: 1000 * 60 * 60,
        refetchOnWindowFocus: false,

    }
    );

    if (isLoading) {
        return (
            <PrivaceStatementsSkeleton />
        )
    }

    return (
        <>
            <Grid container flexDirection={"column"} justifyContent={"space-between"} padding={"20px"} sx={{ height: "100%" }}>
                <Grid item sx={{ fontWeight: "bold", textAlign: "center", color: "#BBA57A", fontSize: "1rem", width: "100%" }}>قوانین و مقررات کمان لند</Grid>
                <Grid item className="text-sm text-justify !p-4 bg-white border-2 border-dashed border-[#D7DBEC] rounded-[5px]" sx={{ height: "calc(100% - 100px)", overflowY: "auto" }}>
                    <div
                        className="viewContract-contract"
                        dangerouslySetInnerHTML={{ __html: privacyStatement! }}
                    />
                </Grid>
                <Grid item >
                    <CustomisedButton title={"متوجه شدم"} disable={false} onClick={() => { unAuthorized_Redux.includes('login') ? dispatch(setUnAuthorizedState({ state: `login ${UUID}` })) : dispatch(setUnAuthorizedState({ state: `otp ${UUID}` })) }} type={"button"} />
                </Grid>
            </Grid>
        </>
    )
}

export default PrivacyStatements